export default {
  parseIncidentReports: function (data) {
    function formattedEventDate(start, end, timeZone) {
      try {
        if (!start || !end) return;
    
        const startDate = new Date(start);
        const endDate   = new Date(end);
    
        // 연도 계산도 toLocaleXXX로 꺼내면 TZ 반영
        const startY = new Intl.DateTimeFormat('en-US', {
          timeZone,
          year: 'numeric'
        }).format(startDate);
        const endY   = new Intl.DateTimeFormat('en-US', {
          timeZone,
          year: 'numeric'
        }).format(endDate);
    
        const sameYear = startY === endY;
    
        // 공통 옵션에 timeZone 포함
        const commonOpts = {
          timeZone,
          month: 'short',
          day:   'numeric'
        };
    
        const startFormatted = new Intl.DateTimeFormat('en-US', commonOpts)
          .format(startDate)
          .replace(/,/g, '');
    
        const endFormatted = new Intl.DateTimeFormat('en-US', commonOpts)
          .format(endDate)
          .replace(/,/g, '');
    
        return `${startY} ${startFormatted} – ${sameYear ? '' : endY + ' '}${endFormatted}`;
      }
      catch (e) {
        return 'unknown date';
      }
    }

    return {
      id: data?.id,
      name: data?.name,
      createdAt: data?.created_at,
      createdBy: data?.created_by,
      reportUrl: data?.report_url,
      eventStartTime: data?.event_start_time,
      eventEndTime: data?.event_end_time,
      formattedEventRange: formattedEventDate(data?.event_start_time, data?.event_end_time, data?.timezone),
      startYear: new Date(data?.event_start_time)?.getFullYear() || 'unknown',
      endYear: new Date(data?.event_end_time)?.getFullYear() || 'unknown',
      attentionOf: data?.attention_of || "No Data",
      authorizedBy: data?.authorized_by || "No Data",
      category: data?.category || "No Data",
      subCategory: data?.sub_category || "No Data",
      policeReference: data?.police_reference || "No Data",
      summaryNote: data?.summary_note || "No Data",
      timezone: data?.timezone || undefined,
    }
  },
  parseIncidentReportLogs: function (data) {
    let type = this.getComponentForLog(data)

    if (type === "arming") {
      if (data.action.toLowerCase().includes('disarm')) type = "disarmed"
      else if (data.action.toLowerCase().includes('arm')) type = "armed"
      else type = data.action
    }

    if (type === "video event") {
      type = "alarm"
    }

    if (type === "timelapse event") {
      type = "timelapse"
    }

    if (type === "playback event") {
      type = "playback"
    }

    // AI 분석이 시도됐다.
    if (data.trigger === "VideoAI") {
      // AI 분석이 성공했다.
      if (data.status_text.toLowerCase() === "alarm" || data.status_text.toLowerCase() === "activity" ) {
        const result = this.parseVideoAIResult(data.meta)
        data._ai = result
        
      }
    }

    const normalized = type.toLowerCase().replace(/\s/g, '');
    data.categoryCassName = normalized
    data.type = type

    return data
  },
  computedCategory(log){
    log.category = log?.category?.toLowerCase()
    
    if(!log?.category || typeof log.category != 'string') return 'default'
    const category = log.category
    return category.toLowerCase()
  },
  getComponentForLog(log){
    let category = this.computedCategory(log)
    const componentName = this.categoryList.includes(category) ? category : 'default'
    return componentName
  },
  parseVideoAIResult(meta){
    if(!meta || typeof meta != 'string') return 'Failed'
    const metaData = JSON.parse(meta)
    const body = metaData?.req?.body
    const entityIds = body?.summary_entity_ids
    if(!entityIds) return 'Failed'

    let cloudResult = ''
    const data = JSON.parse(entityIds)
    const result = Object.values(data)

    let person = ''
    let vehicle = ''
    const isAllPerson = result.every((entity) => entity?.includes('person'))
    const isAllVehicle = result.every((entity) => entity?.includes('vehicle'))

    if(data.static?.length) {
      if(data.static.includes('person')) person = 'Stationary Person'
      if(data.static.includes('vehicle')) vehicle = 'Stationary Vehicle'
    }
    if(data.motion?.length) {
      if(data.motion.includes('person')) person = 'Moving Person'
      if(data.motion.includes('vehicle')) vehicle = 'Moving Vehicle'
    }

    if(isAllPerson) person = 'Person'
    if(isAllVehicle) vehicle = 'Vehicle'

    if(person && vehicle) {
      cloudResult = `${person}, ${vehicle}`
    } else if(person || vehicle) {
      cloudResult = `${person || vehicle}`
    } else if(!person && !vehicle) {
      cloudResult = 'Nothing Detected'
    }
    return cloudResult
  },
  categoryList: [
    'video event', 
    'arming', 
    'audio', 
    'default', 
    'playback event', 
    'relay',  
    'timelapse event', 
    'verification', 
    'disarmed event'
  ]

}